import { Direction } from '@modules/common/types';
import { MAX_CELLS_PER_ROW, ROW_COL_SPAN } from '@modules/dashboard/constants';
import { getDashboardRow } from '@modules/dashboard/helpers/getDashboardRow';
import { getNewRowID } from '@modules/dashboard/helpers/getNewRowID';
import { DashboardCell, DashboardLayout } from 'generated/graphql';

interface addCellToDashboardLayoutParams {
  rowID?: string | null;
  cell: DashboardCell;
  layout: DashboardLayout;
  cellInsertDirection: Direction;
}

export function addCellToDashboardLayout({
  rowID,
  layout,
  cell,
  cellInsertDirection,
}: addCellToDashboardLayoutParams) {
  const rows = layout.rows;
  let destinationRowID: string;
  const row = rowID ? getDashboardRow({ rowID, rows }) : null;

  if (row) {
    if (
      row.cells.length === MAX_CELLS_PER_ROW ||
      cellInsertDirection === Direction.Bottom ||
      cellInsertDirection === Direction.Top
    ) {
      const newRow = {
        id: getNewRowID(),
        height: 0,
        cells: [cell],
      };
      destinationRowID = newRow.id;

      const getPlacementIdx = () => {
        if (!rowID) {
          return 0;
        }

        const rowIndex = rows.findIndex((item) => item.id === rowID);

        if (rowIndex === -1) {
          return 0;
        }

        return cellInsertDirection === Direction.Top ? rowIndex : rowIndex + 1;
      };

      rows.splice(getPlacementIdx(), 0, newRow);
    } else {
      destinationRowID = row.id;

      if (cellInsertDirection === Direction.Left) {
        row.cells.unshift(cell);
      } else {
        row.cells.push(cell);
      }

      row.cells.forEach((cell) => {
        cell.columnSpan = ROW_COL_SPAN / row.cells.length;
      });
    }
  } else {
    const newRow = {
      id: getNewRowID(),
      height: 0,
      cells: [cell],
    };
    destinationRowID = newRow.id;

    rows.push(newRow);
  }

  return { destinationRowID };
}
